import { EDocumentIds } from "./model"

export const VehicleSelectionDocuments: EDocumentIds[] = [EDocumentIds.GVA, EDocumentIds.Batterie]

export const UncountableFields = ["complainInfo.isAdditionalCosts", "batteryInfo.enableDeinstallationCost"]
